import React from "react";

export default function IconText({
	iconUrl = "",
	text = "Icon Text",
	className,
	onClick = () => {},
}) {
	return (
		<div className={`flex gap-1 cursor-pointer ${className}`} onClick={onClick}>
			<img alt="icon" src={iconUrl} />
			<p className="">{text}</p>
		</div>
	);
}
